import {
  Activity, Award, BrainCircuit, Building2, Calendar, CalendarDays, Camera, CheckCircle,
  Clock, Dumbbell, Gauge, Gift, Heart, Mail, MapPin, Phone, ShieldCheck,
  Star, Swords, Target, TrendingUp, Trophy, Users, Zap,
} from "lucide-react";

export const cmsIconMap = {
  Activity, Award, BrainCircuit, Building2, Calendar, CalendarDays, Camera, CheckCircle,
  Clock, Dumbbell, Gauge, Gift, Heart, Mail, MapPin, Phone, ShieldCheck,
  Star, Swords, Target, TrendingUp, Trophy, Users, Zap,
};

export const cmsIconOptions = Object.keys(cmsIconMap).map((name) => ({ value: name, label: name }));

export function CmsIcon({ name, ...props }) {
  const Icon = cmsIconMap[name];
  if (!Icon) return null;
  return <Icon {...props} />;
}
